import {Component} from 'react';
import {Translate, I18n} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import {Icon} from 'front-onceforall-core';

export class DossierOverviewAndActions extends Component {
  render() {
    const downloadCommand = (<button
      type="button"
      className={`primary inline-container no-wrap ${this.props.big ? 'large' : 'small'}`}
      onClick={this.props.onDownloadDossierOverview}
      data-id="downloadDossierOverviewButton"
      disabled={this.props.downloadDisabled}
      style={this.props.downloadDisabled ? {pointerEvents: 'none'} : {}}
    >
      <Icon icon="download"/>
      <Translate value="dossier.download.dossierOverview"/>
    </button>);
    let commandWrapper = downloadCommand;

    if (this.props.downloadDisabled) {
      commandWrapper = (<Tooltip
        data-id="dossier-overview-download-command-tooltip"
        title={I18n.t(this.props.downloadDisabledTooltipKey)}
        placement="bottom"
      >
        <span>{downloadCommand}</span>
      </Tooltip>);
    }

    return (<span className="inline-container">
      {Boolean(this.props.onDownloadDossierOverview) && commandWrapper}
      {this.props.children}
    </span>);
  }
}

DossierOverviewAndActions.defaultProps = {
  big: false
};

DossierOverviewAndActions.propTypes = {
  onDownloadDossierOverview: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  big: PropTypes.bool,
  downloadDisabled: PropTypes.bool.isRequired,
  downloadDisabledTooltipKey: PropTypes.string.isRequired
};

export default DossierOverviewAndActions;
